import { render } from "./ChangeItemStateModal.vue?vue&type=template&id=61a8d8d0&scoped=true"
import script from "./ChangeItemStateModal.vue?vue&type=script&lang=js"
export * from "./ChangeItemStateModal.vue?vue&type=script&lang=js"

import "./ChangeItemStateModal.vue?vue&type=style&index=0&id=61a8d8d0&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a8d8d0"]])

export default __exports__